<template>
    <div>
        <el-button
            title="Search"
            icon="mdi mdi-account-search"
            class="search-icon"
            @click="handleOpen"
        />
        <el-dialog
            title="Search Order"
            :visible.sync="dialogVisible"
            width="60%"
            :before-close="handleClose"
        >
            <el-input
                placeholder="Search Order"
                v-model="searchOrder"
                class="input-with-select"
                @change="getOrders"
            >
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getOrders"
                ></el-button>
            </el-input>
            <template>
                <el-table
                    :data="orders"
                    :default-sort="{ prop: 'id', order: 'descending' }"
                    height="400px"
                    v-loading="loading"
                    element-loading-text="Loading..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column prop="id" label="Order #" sortable>
                    </el-table-column>
                    <el-table-column prop="community.name" label="Customer">
                    </el-table-column>
                    <el-table-column
                        prop="created_at"
                        label="Order Placed"
                        :formatter="formatter"
                    >
                    </el-table-column>
                    <el-table-column prop="formatted_month" label="Issue">
                    </el-table-column>
                    <el-table-column prop="formatted_status" label="Status">
                    </el-table-column>
                    <el-table-column label="Tracking Info">
                        <template slot-scope="{ row }">
                            <a
                                :href="`/web-api/order/${row.id}/track`"
                                target="_blank"
                                >Track Order <i class="mdi mdi-open-in-new"
                            /></a>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="{ row }">
                            <el-button plain @click="openOrder(row.id)">
                                <i class="mdi mdi-eye"></i>
                                View
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import auth from "@/mixins/auth";
import * as Routes from "@/constants/routes";

export default {
    mixins: [auth],
    props: {},
    directives: {},
    components: {},
    data() {
        return {
            Routes,
            dialogVisible: false,
            searchOrder: null,
            orders: [],
            select: "1",
            loading: false,
        };
    },
    mounted() {},
    methods: {
        handleClose() {
            this.dialogVisible = false;
        },
        handleOpen() {
            this.orders = [];
            this.searchOrder = null;
            this.dialogVisible = true;
        },
        getOrders() {
            let $vm = this;
            $vm.orders = [];
            $vm.loading = true;
            axios
                .get("/web-api/order/search?include=community", {
                    params: {
                        search: $vm.searchOrder,
                    },
                })
                .then(function (response) {
                    $vm.orders = response.data.data;
                    $vm.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    $vm.loading = false;
                });
            // if ($vm.select == 1) {
            //     axios.get('/web-api/order/search?include=community', {
            //         params: {
            //             search: $vm.searchOrder
            //         }
            //     })
            //     .then(function (response) {
            //         $vm.orders = response.data.data;
            //         $vm.loading = false;
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //         $vm.loading = false;
            //     });
            // } else {
            //     axios.get('/web-api/order/search?include=community', {
            //         params: {
            //             search: $vm.searchOrder
            //         }
            //     })
            //     .then(function (response) {
            //         $vm.orders = response.data.data;
            //         $vm.loading = false;
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //         $vm.loading = false;
            //     });
            // }
        },
        openOrder(id) {
            this.dialogVisible = false;
            this.orders = [];
            this.searchOrder = null;
            this.$router.push({
                name: Routes.VIEW_ORDER,
                params: { id: id },
            });
        },
        formatter(row, column) {
            return moment(row.created_at).format("MMM DD, YYYY hh:mma");
        },
    },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
    text-align: left !important;
}
.search-icon {
    font-size: 35px;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    color: rgba(74, 89, 106, 0.3);
}
.search-icon:hover {
    color: #5f8fdf;
}
</style>
